export default __webpack_public_path__ + "static/media/044-the gherkin.5c26a90a.svg";